import axios from "axios";
import config from './utils/config.json';

declare global {
  interface Window {
    RUNTIME_CONFIG?: {
      apimSubscriptionKey?: string;
    };
  }
}

function getConfiguration() {
  let env = window.location.hostname;
  let envConfig = {};

  if(env.includes("test")){
    envConfig = config["test"];
  }
  else if(env.includes("qa")){
    envConfig = config["qa"];
  }
  else if(env.includes("prod")){
    envConfig = config["prod"];
  }
  else {
    envConfig = config["localhost"];
  }

  return envConfig;
}

export let EnvConfigs = getConfiguration();

// Get the APIM key from runtime config if available
const apimKey = window.RUNTIME_CONFIG?.apimSubscriptionKey;

export default axios.create({
  baseURL: EnvConfigs['apiUrl'],
  headers: {
    "Content-type": "application/json",
    ...(apimKey && { "Ocp-Apim-Subscription-Key": apimKey })
  }
});